import "./WaterHeaterRepair.module.css";
import Header from "@/reusable_sections/Header";
import WaterHeater from "./sections/WaterHeater";
import WaterProblems from "./sections/WaterProblems";
import HeaterDecision from "./sections/HeaterDecision";
import HeaterTechnical from "./sections/HeaterTechnical";
import FeaturedServices from "./sections/FeaturedServices";
import ProblemCategories from "./sections/ProblemCategories";
import JonesboroArea from "./sections/JonesboroArea";
import HeaterFAQ from "./sections/HeaterFAQ";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function WaterHeaterRepairPage() {
  return <div>
      <Header />
      <WaterHeater />
      <WaterProblems />
      <HeaterDecision />
      <HeaterTechnical />
      <FeaturedServices />
      <ProblemCategories />
      <JonesboroArea />
      <HeaterFAQ />
      <EmergencyCta />
      <Footer />
    </div>;
}